<template>
	<v-expand-transition>
		<v-alert
			v-if="visible"
			variant="tonal"
			color="primary"
			border="start"
			rounded="lg"
			class="mfa-reminder mb-4"
		>
			<div class="d-flex align-center flex-wrap ga-3">
				<v-icon size="28" color="primary" class="flex-grow-0">
					mdi-shield-key-outline
				</v-icon>
				<div class="flex-grow-1 mfa-reminder__text">
					<div class="font-weight-bold">{{ $t("mfa.reminder.title") }}</div>
					<div class="text-body-2 text-medium-emphasis">
						{{ $t("mfa.reminder.text") }}
					</div>
				</div>
				<div class="d-flex align-center ga-1">
					<v-btn
						color="primary"
						variant="flat"
						size="small"
						prepend-icon="mdi-shield-plus-outline"
						@click="goActivate"
					>
						{{ $t("mfa.reminder.activate") }}
					</v-btn>
					<v-btn
						variant="text"
						size="small"
						icon="mdi-close"
						:title="$t('mfa.reminder.dismiss')"
						@click="dismiss"
					/>
				</div>
			</div>
		</v-alert>
	</v-expand-transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import apiService from "@/services/api";
import { getMfaStatus } from "@/services/mfaService";

const router = useRouter();
const authStore = useAuthStore();
const visible = ref(false);

onMounted(async () => {
	// Já dispensado pelo usuário? não mostra.
	if (authStore.user?.completedTours?.mfaReminder === true) return;
	try {
		const status = await getMfaStatus();
		if (!status.enabled) visible.value = true;
	} catch {
		// silencioso — não atrapalha o dashboard se a checagem falhar
	}
});

function goActivate() {
	router.push({ path: "/profile", query: { tab: "security" } });
}

async function dismiss() {
	visible.value = false;
	// Atualiza local imediatamente para não reaparecer na sessão
	if (authStore.user) {
		authStore.user.completedTours = {
			...authStore.user.completedTours,
			mfaReminder: true,
		};
	}
	try {
		const result = await apiService.patch("/auth/tours", {
			tourKey: "mfaReminder",
			completed: true,
		});
		if (authStore.user) authStore.user.completedTours = result.completedTours;
	} catch (err) {
		console.error("Erro ao salvar dispensa do lembrete de MFA:", err);
	}
}
</script>

<style lang="scss" scoped>
.mfa-reminder__text {
	min-width: 200px;
}
</style>
